// Copyright (c) 2025 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import api from './advisorApi';
import type {
  ProviderSummaryDTO,
  ProviderDetailDTO,
  ProviderListFilters,
} from '../types/provider';

export const providerApi = {
  /**
   * Get all providers for logged-in advisor with aggregated counts
   */
  getProviders: async (filters: ProviderListFilters = {}): Promise<ProviderSummaryDTO[]> => {
    const params: Record<string, string | number | boolean | undefined> = {};

    if (filters.search) params.searchQuery = filters.search;
    if (filters.sortBy) {
      params.sortBy = filters.sortBy;
      params.sortOrder = (filters.sortDirection || 'desc').toUpperCase();
    }
    if (filters.hasOpenLoas !== undefined) params.hasOpenLoas = filters.hasOpenLoas;

    const response = await api.get<ProviderSummaryDTO[]>('/advisor/providers', { params });
    return response.data;
  },

  /**
   * Get provider details with LOAs and policies
   */
  getProviderDetail: async (
    providerId: string,
    loaPage: number = 0,
    loaSize: number = 10
  ): Promise<ProviderDetailDTO> => {
    const response = await api.get<ProviderDetailDTO>(`/advisor/providers/${providerId}`, {
      params: {
        loaPage,
        loaSize,
      },
    });
    return response.data;
  },
};
